import React, { useEffect } from 'react';
import { Box, Grid, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthLogic } from '../hooks/useAuthLogic';
import LeftSection from './components/LeftSection';
import RightSection from './components/RightSection';
import { useUniversityConfig } from '../../../contexts/UniversityConfigProvider';
import { useAuth } from '../../../contexts/AuthProvider';
import { useThemeMode } from '../../../contexts/ThemeProvider';
import AppLoader from '../../../components/common/AppLoader';

const containerStyles = (config: any, isDark: boolean) => ({
  minHeight: '100vh',
  backgroundColor: isDark ? '#121212' : '#f8fafc',
  fontFamily: config?.theme?.fonts?.primary 
});

const Login: React.FC = () => {
  const { config } = useUniversityConfig();
  const { isAuthenticated, isLoading } = useAuth();
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  const navigate = useNavigate();
  const authLogic = useAuthLogic();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) return <AppLoader message="Checking authentication..." />;
  if (isAuthenticated) return null;

  const showLeftSection = !isMobile && config?.login?.leftSection?.enabled !== false;
  const isContentOnRight = config?.login?.layout?.contentSide === 'right';

  return (
    <Box sx={containerStyles(config, isDark)}>
      <Grid container sx={{ minHeight: '100vh' }}>
        {showLeftSection && !isContentOnRight && <LeftSection config={config} />}
        <RightSection authLogic={authLogic} config={config} />
        {showLeftSection && isContentOnRight && <LeftSection config={config} />}
      </Grid>
    </Box>
  );
};

export default Login;